var styles = {
  "Spinner": "pb-Spinner__Spinner",
  "spinner-container-rotate": "pb-Spinner__spinner-container-rotate",
  "spinnerLayer": "pb-Spinner__spinnerLayer",
  "spinner-fill-unfill-rotate": "pb-Spinner__spinner-fill-unfill-rotate",
  "gapPatch": "pb-Spinner__gapPatch",
  "circle": "pb-Spinner__circle",
  "circleClipper": "pb-Spinner__circleClipper",
  "left": "pb-Spinner__left",
  "spinner-left-spin": "pb-Spinner__spinner-left-spin",
  "right": "pb-Spinner__right",
  "spinner-right-spin": "pb-Spinner__spinner-right-spin"
};
export default styles;